import React from 'react'



import services_image1 from "../assets/services_image1.jpg"
import services_image2 from "../assets/services_image2.jpg"
import services_image3 from "../assets/services_image3.jpg"
import OwlCrousel from './OwlCrousel'


const SpecialPrograms = () => {

    const services = [
        { img: `${services_image1}`, color: "#ed5d74", heading: "Learning & Fun", description: "Pllentesque habitant mtristique senectus netus esu ada faes ac tuivam imperdiet rutrumhla." },
        { img: `${services_image2}`, color: "#6453ee", heading: "Healthy Meals", description: "Pllentesque habitant mtristique senectus netus esu ada faes ac tuivam imperdiet rutrumhla." },
        { img: `${services_image3}`, color: "#ffb132", heading: "Children Safety", description: "Pllentesque habitant mtristique senectus netus esu ada faes ac tuivam imperdiet rutrumhla." },
        { img: `${services_image3}`, color: "#01c8c5", heading: "Children Safety", description: "Pllentesque habitant mtristique senectus netus esu ada faes ac tuivam imperdiet rutrumhla." },
    ]


    return (
        <div>
            <div>
                <div className='service_container bg-[#ffefe4] py-[20px] mt-[150px]'>
                    <div className='heading_container text-center '>
                        <p className='text-main-color font-sans font-semibold text-[21px]'>Special Programs</p>
                        <h3 className='text-[32px] text-[#161616] font-semibold'>Play, Educate, And Develop </h3>
                        <h3 className='text-[32px] text-[#161616] font-semibold'>Together</h3>
                    </div>

                    <div className='card_container w-[1300px] flex gap-[40px] justify-center items-center flex-wrap mt-[80px] ml-auto mr-auto' >
                        {
                            services && services.map((item, index) => {
                                return (
                                    <div className='card  flex flex-wrap w-[550px] '>
                                        <div style={{ backgroundColor: `${item.color}` }} className={` px-[40px] py-[60px] text-white  rounded-[25px]  flex gap-[20px] justify-center items-center w-full`}>
                                            <div className='rounded-full  ml-auto mr-auto w-[30%]'>
                                                <img className='rounded-full w-full h-full border-[8px] border-white' src={item.img} alt="" />
                                            </div>
                                            <div className=' w-[70%]'>
                                                <h3 className='text-[20px] font-semibold mb-[20px]'>{item.heading}</h3>
                                                <p className='text-[16px] font-normal'>
                                                    {item.description}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                )
                            })
                        }





                    </div>

                </div>
            </div>

            {/* <OwlCrousel/> */}
        </div>
    )
}

export default SpecialPrograms